export default {
  jobListingSearches: [],
  jobListingSearch: undefined,
};
